/** 参数只取真实书籍/栏目数据；无值字段交给传输层省略。 */
export function bookParams(book: Record<string, any>, pos?: number) {
  return {
    book_id: book.id ?? book.contentId,
    book_name: book.contentName,
    author: book.authorInfo?.author ?? book.author,
    pos,
    serial_status: book.finishStatus == null ? undefined : book.finishStatus === 0 ? 'ongoing' : 'completed',
    column_id: book.module_id,
    column_name: book.module_name,
  }
}
export function bookEvent(page: string, action: 'exp' | 'ck') {
  const prefix = page === 'search' ? 'search_result' : ['collection', 'ranking', 'tags'].includes(page) ? 'column_book_list_book' : 'book'
  return `${prefix}_${action}`
}
